export type AttachmentState = "uploading" | "ready" | "error";

export type ComposerAttachment = {
  localId: string;
  filename: string;
  byteSize: number;
  state: AttachmentState;
  attachmentId?: string;
  error?: string;
};

const UNITS = ["B", "KB", "MB", "GB"];

export function formatBytes(bytes: number): string {
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value < 10 && unit > 0 ? value.toFixed(1) : Math.round(value)} ${UNITS[unit]}`;
}

export function extensionOf(filename: string): string {
  const dot = filename.lastIndexOf(".");
  return dot === -1 ? "" : filename.slice(dot + 1).toLowerCase();
}

type Props = {
  filename: string;
  byteSize?: number;
  state?: AttachmentState;
  error?: string;
  onRemove?: () => void;
};

export function AttachmentChip({ filename, byteSize, state = "ready", error, onRemove }: Props) {
  const ext = extensionOf(filename);
  return (
    <span className={`attachment-chip ${state}`} title={error ?? filename}>
      <span className="attachment-ext">{ext || "file"}</span>
      <span className="attachment-name">{filename}</span>
      {state === "uploading" && <span className="attachment-status">uploading…</span>}
      {state === "error" && <span className="attachment-status">failed</span>}
      {state === "ready" && byteSize != null && (
        <span className="attachment-size">{formatBytes(byteSize)}</span>
      )}
      {onRemove && (
        <button
          type="button"
          className="attachment-remove"
          onClick={onRemove}
          aria-label={`Remove ${filename}`}
        >
          ×
        </button>
      )}
    </span>
  );
}
